import React, { useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { apiClient } from '../services/apiClient'

export function AcceptInvitePage() {
  const location = useLocation()

  const token = useMemo(() => {
    const params = new URLSearchParams(location.search)
    return params.get('token') || ''
  }, [location.search])

  const [fullName, setFullName] = useState('')
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const submit = async () => {
    if (!token) {
      setError('Missing invite token')
      return
    }
    if (password.length < 8) {
      setError('Password must be at least 8 characters')
      return
    }
    if (password !== confirm) {
      setError('Passwords do not match')
      return
    }

    setIsSubmitting(true)
    setError(null)
    try {
      await apiClient.acceptInvite(token, password, fullName.trim() || undefined)
      window.location.href = '/'
    } catch (e: any) {
      setError(e?.message || 'Failed to accept invite')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: 'linear-gradient(to bottom right, var(--cream), var(--sand))' }}>
      <div className="w-full max-w-md rounded-lg border p-6" style={{ borderColor: 'var(--sand)', background: 'var(--warm-white)' }}>
        <h1 className="text-2xl font-semibold" style={{ fontFamily: 'Crimson Text, Georgia, serif', color: 'var(--charcoal)' }}>
          Set your password
        </h1>
        <p className="mt-2 text-sm" style={{ fontFamily: 'DM Sans, sans-serif', color: 'var(--charcoal-light)' }}>
          Finish setting up your account.
        </p>

        {error && (
          <div className="mt-4 p-3 rounded-md" style={{ background: 'rgba(239, 68, 68, 0.08)', color: '#991b1b' }}>
            {error}
          </div>
        )}

        <div className="mt-4" style={{ fontFamily: 'DM Sans, sans-serif' }}>
          <label className="block text-xs mb-1" style={{ color: 'var(--charcoal-light)' }}>
            Full name (optional)
          </label>
          <input
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            className="w-full px-3 py-2 rounded-md border"
            style={{ borderColor: 'var(--sand)', background: 'var(--warm-white)' }}
            placeholder="Jane Doe"
          />
        </div>

        <div className="mt-3" style={{ fontFamily: 'DM Sans, sans-serif' }}>
          <label className="block text-xs mb-1" style={{ color: 'var(--charcoal-light)' }}>
            Password
          </label>
          <input
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-3 py-2 rounded-md border"
            style={{ borderColor: 'var(--sand)', background: 'var(--warm-white)' }}
            type="password"
            placeholder="Minimum 8 characters"
          />
        </div>

        <div className="mt-3" style={{ fontFamily: 'DM Sans, sans-serif' }}>
          <label className="block text-xs mb-1" style={{ color: 'var(--charcoal-light)' }}>
            Confirm password
          </label>
          <input
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            className="w-full px-3 py-2 rounded-md border"
            style={{ borderColor: 'var(--sand)', background: 'var(--warm-white)' }}
            type="password"
          />
        </div>

        <div className="mt-6 flex justify-end">
          <button
            onClick={submit}
            disabled={isSubmitting}
            className="px-4 py-2 rounded-md font-medium"
            style={{
              background: isSubmitting ? 'rgba(200, 88, 53, 0.08)' : 'var(--terracotta)',
              color: isSubmitting ? 'var(--terracotta)' : 'white',
              fontFamily: 'DM Sans, sans-serif',
            }}
          >
            {isSubmitting ? 'Submitting…' : 'Set password'}
          </button>
        </div>
      </div>
    </div>
  )
}
